import './RecentList.scss'

import { HDSButton } from '@here/hds-react-components'
import List, { DividerProps } from 'components/App/components/List'
import { ScrollableContainer } from 'components/App/components/ScrollableContainer'
import { SearchResultItem } from 'components/SearchResultItem'
import { i18n } from 'lib/i18n'
import React, { MouseEvent, useState } from 'react'
import { RecentItemType, SerializedRecentItem } from 'utils/storage'

interface RecentListProps {
  itemList: SerializedRecentItem[]
  mapSearchParamStr: string | null
  OnItemMouseDown?: (item: SerializedRecentItem) => void
  onItemClick: (item: SerializedRecentItem) => void
  onClearAllClick: (e: MouseEvent) => void
  onDeleteItem?: (e: MouseEvent, id: string) => void
}

export default function RecentList({
  itemList,
  mapSearchParamStr,
  OnItemMouseDown,
  onItemClick,
  onClearAllClick,
  onDeleteItem,
}: RecentListProps): JSX.Element {
  const [highlightedRecentItemId, setHighlightedRecentItemId] = useState<string | undefined>()
  const dividerOptions: DividerProps = { position: { left: '3.125rem' } }

  const handleMouseEnter = (item: SerializedRecentItem): void => {
    setHighlightedRecentItemId(item.placeId)
  }

  const handleMouseLeave = (): void => {
    setHighlightedRecentItemId(undefined)
  }

  // TODO: Disabled for now
  const showClearAll =
    (itemList.length > 1 ||
      (itemList.length > 0 && itemList[0].type !== RecentItemType.currentLocation)) &&
    false

  return (
    <div className="SearchResultList-container">
      <ScrollableContainer className="SearchResultList-scrollable-container">
        <List className="SearchResultList" divider={dividerOptions}>
          {itemList.map((item, index) => {
            const isCurrentLocation = item.type === RecentItemType.currentLocation
            return (
              <SearchResultItem
                key={index}
                iconName={
                  isCurrentLocation
                    ? 'current-location'
                    : item.type === RecentItemType.freeText
                    ? 'search'
                    : undefined
                }
                iconCategory={isCurrentLocation ? 'map-view' : undefined}
                iconColor={isCurrentLocation ? 'var(--hds-accent)' : undefined}
                categoryId={item.placeCategoryId}
                kind={'recent'}
                link={mapSearchParamStr !== null ? getResultItemLink(item, mapSearchParamStr) : ''}
                title={item.type === RecentItemType.freeText ? `"${item.title}"` : item.title}
                highlightedSubtitle={item.distanceLabel}
                subtitle={item.address}
                isHighlighted={highlightedRecentItemId === item.placeId}
                onClick={() => onItemClick(item)}
                onMouseEnter={() => handleMouseEnter(item)}
                onMouseLeave={handleMouseLeave}
                onMouseDown={() => OnItemMouseDown && OnItemMouseDown(item)}
                onDeleteItem={(e) => onDeleteItem && onDeleteItem(e, item.placeId)}
              />
            )
          })}
        </List>
      </ScrollableContainer>

      {showClearAll && (
        <div className="RoutePlanner__clear-all-container">
          <HDSButton size="small" variant="subtle-quiet" onMouseDown={onClearAllClick}>
            {i18n('search.recent.clear')}
          </HDSButton>
        </div>
      )}
    </div>
  )
}

function getResultItemLink(
  resultItem: SerializedRecentItem,
  mapSearchParamStr: string | null
): string {
  const link =
    resultItem.type === 'freeText' ? `/discover/${resultItem.title}` : `/p/${resultItem.placeId}`
  return mapSearchParamStr === null ? link : `${link}?map=${mapSearchParamStr}`
}
